/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"


/**
 * Сервис предоставляет возможность управлять шаблонами приборов телеметрии
 */

/**
 * Сервис управления шаблонами приборов телеметрии.
 * Авторизация:
 *   - Authorization: Bearer token
 */
export class TemplateServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод получения шаблона ПУ.
   * Метод доступен для: Token: service, application, admin, owner, employee, bti, seller. Без учета разрешений
   */
  GetTemplateDevice = (req: GetTemplateDeviceRequestDto, init?: RequestInit): Promise<GetTemplateDeviceResponseDto> => {
    return fm.request<GetTemplateDeviceRequestDto, GetTemplateDeviceResponseDto>(`${this.host}/telemetry_control/api/v1/template/device/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения списка шаблонов ПУ.
   * Метод доступен для: Token: service, application, admin, owner, employee, bti, seller. Без учета разрешений
   */
  GetTemplateDeviceList = (req?: GetTemplateDeviceListRequestDto, init?: RequestInit): Promise<GetTemplateDeviceListResponseDto[]> => {
    return fm.list<GetTemplateDeviceListRequestDto, GetTemplateDeviceListResponseDto>(`${this.host}/telemetry_control/api/v1/template/device/list${fm.buildQuery(req)}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
  /**
   * Метод получения количества шаблонов ПУ.
   * Метод доступен для: Token: service, application, admin, owner, employee, bti, seller. Без учета разрешений
   */
  GetTemplateDeviceCount = (req?: GetTemplateDeviceCountRequestDto, init?: RequestInit): Promise<GetTemplateDeviceCountResponseDto> => {
    return fm.request<GetTemplateDeviceCountRequestDto, GetTemplateDeviceCountResponseDto>(`${this.host}/telemetry_control/api/v1/template/device/count${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод сохранения шаблона ПУ.
   * Поддерживает создание и обновление.
   * Метод доступен для: Token: admin, service, application. Без учета разрешений
   */
  PostTemplateDevice = (req: PostTemplateDeviceRequestDto, init?: RequestInit): Promise<PostTemplateDeviceResponseDto> => {
    return fm.request<PostTemplateDeviceRequestDto, PostTemplateDeviceResponseDto>(`${this.host}/telemetry_control/api/v1/template/device`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод удаления шаблона ПУ.
   * Метод доступен для: Token: admin, service, application. Без учета разрешений
   */
  DeleteTemplateDevice = (req: DeleteTemplateDeviceRequestDto, init?: RequestInit): Promise<DeleteTemplateDeviceResponseDto> => {
    return fm.request<DeleteTemplateDeviceRequestDto, DeleteTemplateDeviceResponseDto>(`${this.host}/telemetry_control/api/v1/template/device/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "DELETE", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения шаблона индикатора.
   * Метод доступен для: Token: service, application, admin, owner, employee, bti, seller. Без учета разрешений
   */
  GetTemplateIndicator = (req: GetTemplateIndicatorRequestDto, init?: RequestInit): Promise<GetTemplateIndicatorResponseDto> => {
    return fm.request<GetTemplateIndicatorRequestDto, GetTemplateIndicatorResponseDto>(`${this.host}/telemetry_control/api/v1/template/indicator/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения списка шаблонов индикаторов.
   * Метод доступен для: Token: service, application, admin, owner, employee, bti, seller. Без учета разрешений
   */
  GetTemplateIndicatorList = (req?: GetTemplateIndicatorListRequestDto, init?: RequestInit): Promise<GetTemplateIndicatorListResponseDto[]> => {
    return fm.list<GetTemplateIndicatorListRequestDto, GetTemplateIndicatorListResponseDto>(`${this.host}/telemetry_control/api/v1/template/indicator/list${fm.buildQuery(req)}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
  /**
   * Метод получения количества шаблонов индикаторов.
   * Метод доступен для: Token: service, application, admin, owner, employee, bti, seller. Без учета разрешений
   */
  GetTemplateIndicatorCount = (req?: GetTemplateIndicatorCountRequestDto, init?: RequestInit): Promise<GetTemplateIndicatorCountResponseDto> => {
    return fm.request<GetTemplateIndicatorCountRequestDto, GetTemplateIndicatorCountResponseDto>(`${this.host}/telemetry_control/api/v1/template/indicator/count${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод сохранения шаблонов индикатора.
   * Поддерживает создание и обновление.
   * Метод доступен для: Token: admin, service, application. Без учета разрешений
   */
  PostTemplateIndicator = (req: PostTemplateIndicatorRequestDto, init?: RequestInit): Promise<PostTemplateIndicatorResponseDto> => {
    return fm.request<PostTemplateIndicatorRequestDto, PostTemplateIndicatorResponseDto>(`${this.host}/telemetry_control/api/v1/template/indicator`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод удаления шаблона шаблона индикатора.
   * Метод доступен для: Token: admin, service, application. Без учета разрешений
   */
  DeleteTemplateIndicator = (req: DeleteTemplateIndicatorRequestDto, init?: RequestInit): Promise<DeleteTemplateIndicatorResponseDto> => {
    return fm.request<DeleteTemplateIndicatorRequestDto, DeleteTemplateIndicatorResponseDto>(`${this.host}/telemetry_control/api/v1/template/indicator/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "DELETE", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Справочние типов энергоресурсов
 */
export enum TemplateDeviceMetricType {
  /**
   * Значение не указано
   */
  METRIC_TYPE_UNKNOWN = "METRIC_TYPE_UNKNOWN",
  /**
   * Горячая вода
   */
  HOT_WATER = "HOT_WATER",
  /**
   * Холодная вода
   */
  COLD_WATER = "COLD_WATER",
  /**
   * Теплоэнергия
   */
  HEAT = "HEAT",
  /**
   * Газ
   */
  GAS = "GAS",
  /**
   * Электроэнергия
   */
  ELECTRICITY = "ELECTRICITY",
}
/**
 * Справочние типов энергоресурсов
 */
export type TemplateDeviceMetricTypeResponseEnum = keyof typeof TemplateDeviceMetricType
/**
 * Справочние типов энергоресурсов
 */
export type TemplateDeviceMetricTypeRequestEnum = Exclude<TemplateDeviceMetricTypeResponseEnum, "METRIC_TYPE_UNKNOWN">;

/**
 * Тип тарифного плана
 */
export enum TemplateDevicePlanType {
  /**
   * Значение не указано
   */
  PLAN_TYPE_UNKNOWN = "PLAN_TYPE_UNKNOWN",
  /**
   * Однотарифный
   */
  SINGLE = "SINGLE",
  /**
   * Двухтарифный
   */
  DOUBLE = "DOUBLE",
  /**
   * Трёхтарифный
   */
  TRIPLE = "TRIPLE",
}
/**
 * Тип тарифного плана
 */
export type TemplateDevicePlanTypeResponseEnum = keyof typeof TemplateDevicePlanType
/**
 * Тип тарифного плана
 */
export type TemplateDevicePlanTypeRequestEnum = Exclude<TemplateDevicePlanTypeResponseEnum, "PLAN_TYPE_UNKNOWN">;

/**
 * Справочник типов направлений сортировки
 */
export enum TemplateDevicePagingDirectionType {
  /**
   * Значение не указано
   */
  DIRECTION_TYPE_UNKNOWN = "DIRECTION_TYPE_UNKNOWN",
  /**
   * От большего к меньшему
   */
  DESC = "DESC",
  /**
   * От меньшего к большему
   */
  ASC = "ASC",
}
/**
 * Справочник типов направлений сортировки
 */
export type TemplateDevicePagingDirectionTypeResponseEnum = keyof typeof TemplateDevicePagingDirectionType
/**
 * Справочник типов направлений сортировки
 */
export type TemplateDevicePagingDirectionTypeRequestEnum = Exclude<TemplateDevicePagingDirectionTypeResponseEnum, "DIRECTION_TYPE_UNKNOWN">;

/**
 * Справочник типов значений сортировки
 */
export enum TemplateDevicePagingOrderByType {
  /**
   * Значение не указано
   */
  ORDER_BY_TYPE_UNKNOWN = "ORDER_BY_TYPE_UNKNOWN",
  /**
   * По идентификатору
   */
  ID = "ID",
  /**
   * По типу энергоресурса
   */
  METRIC_TYPE = "METRIC_TYPE",
  /**
   * По модели счетчика
   */
  MODEL = "MODEL",
}
/**
 * Справочник типов значений сортировки
 */
export type TemplateDevicePagingOrderByTypeResponseEnum = keyof typeof TemplateDevicePagingOrderByType
/**
 * Справочник типов значений сортировки
 */
export type TemplateDevicePagingOrderByTypeRequestEnum = Exclude<TemplateDevicePagingOrderByTypeResponseEnum, "ORDER_BY_TYPE_UNKNOWN">;

/**
 * Справочник типа архивности показаний.
 * Используется для указания за какой период произошло измерение.
 * По умолчанию CURRENT
 */
export enum TemplateIndicatorArchiveType {
  /**
   * Значение не указано
   */
  ARCHIVE_TYPE_UNKNOWN = "ARCHIVE_TYPE_UNKNOWN",
  /**
   * Текущие показания
   */
  CURRENT = "CURRENT",
  /**
   * За 30 мин
   */
  HALFHOUR = "HALFHOUR",
  /**
   * За час
   */
  HOUR = "HOUR",
  /**
   * За суток
   */
  DAY = "DAY",
  /**
   * За месяц
   */
  MONTH = "MONTH",
  /**
   * За год
   */
  YEAR = "YEAR",
}
/**
 * Справочник типа архивности показаний.
 * Используется для указания за какой период произошло измерение.
 * По умолчанию CURRENT
 */
export type TemplateIndicatorArchiveTypeResponseEnum = keyof typeof TemplateIndicatorArchiveType
/**
 * Справочник типа архивности показаний.
 * Используется для указания за какой период произошло измерение.
 * По умолчанию CURRENT
 */
export type TemplateIndicatorArchiveTypeRequestEnum = Exclude<TemplateIndicatorArchiveTypeResponseEnum, "ARCHIVE_TYPE_UNKNOWN">;

/**
 * Справочник типов измерений
 */
export enum TemplateIndicatorSignType {
  /**
   * Значение не указано
   */
  SIGN_TYPE_UNKNOWN = "SIGN_TYPE_UNKNOWN",
  /**
   * Абсолютный показатель
   */
  ABSOLUTE_DS = "ABSOLUTE_DS",
  /**
   * Абсолютный расход ресурса
   */
  ABSOLUTE_RC = "ABSOLUTE_RC",
  /**
   * Интервальный показатель состояния
   */
  INTERVAL_DS = "INTERVAL_DS",
  /**
   * Интервальный расход ресурса
   */
  INTERVAL_RC = "INTERVAL_RC",
  /**
   * Текущее состояние
   */
  CURRENT_DS = "CURRENT_DS",
  /**
   * Текущее состояние ресурса
   */
  CURRENT_RS = "CURRENT_RS",
  /**
   * Объём
   */
  VOLUME = "VOLUME",
  /**
   * Параметр конфигурации
   */
  PARAMETER = "PARAMETER",
  /**
   * Флаг состояния
   */
  FLAG = "FLAG",
}
/**
 * Справочник типов измерений
 */
export type TemplateIndicatorSignTypeResponseEnum = keyof typeof TemplateIndicatorSignType
/**
 * Справочник типов измерений
 */
export type TemplateIndicatorSignTypeRequestEnum = Exclude<TemplateIndicatorSignTypeResponseEnum, "SIGN_TYPE_UNKNOWN">;

/**
 * Справочник типов единиц измерений
 */
export enum TemplateIndicatorUnitType {
  /**
   * Значение не указано
   */
  UNIT_TYPE_UNKNOWN = "UNIT_TYPE_UNKNOWN",
  /**
   * Процент
   */
  PERCENT = "PERCENT",
  /**
   * Градус по Цельсию
   */
  C = "C",
  /**
   * Ватт
   */
  WT = "WT",
  /**
   * Гигакалория
   */
  GKAL = "GKAL",
  /**
   * Количество
   */
  VALUE = "VALUE",
  /**
   * Киловaтт-час
   */
  KWH = "KWH",
  /**
   * Килограмм на квадратный сантиметр
   */
  KG_CM2 = "KG_CM2",
  /**
   * Килограмм-сила на квадратный сантиметр
   */
  KGF_CM2 = "KGF_CM2",
  /**
   * Кубический метр
   */
  M3 = "M3",
  /**
   * Кубический метр в час
   */
  M3_H = "M3_H",
  /**
   * Мегапаскаль
   */
  MPA = "MPA",
  /**
   * Миллисекунда
   */
  MS = "MS",
  /**
   * Флаг состояния
   */
  BOOLEAN = "BOOLEAN",
  /**
   * Тонна
   */
  T = "T",
  /**
   * Тонна в час
   */
  T_H = "T_H",
  /**
   * Час
   */
  H = "H",
  /**
   * Безразмерная величина
   */
  NON_MEASURABLE = "NON_MEASURABLE",
  /**
   * Импульс
   */
  IMP = "IMP",
  /**
   * Джоуль
   */
  J = "J",
  /**
   * Килоджоуль
   */
  KJ = "KJ",
  /**
   * Гигаджоуль
   */
  GJ = "GJ",
  /**
   * Ватт-час
   */
  WTH = "WTH",
  /**
   * Киловатт
   */
  KWT = "KWT",
  /**
   * Минута
   */
  MIN = "MIN",
  /**
   * Секунда
   */
  S = "S",
}
/**
 * Справочник типов единиц измерений
 */
export type TemplateIndicatorUnitTypeResponseEnum = keyof typeof TemplateIndicatorUnitType
/**
 * Справочник типов единиц измерений
 */
export type TemplateIndicatorUnitTypeRequestEnum = Exclude<TemplateIndicatorUnitTypeResponseEnum, "UNIT_TYPE_UNKNOWN">;

/**
 * Посредники получения показаний
 */
export enum TemplateIndicatorVendorType {
  /**
   * Значение не указано
   */
  VENDOR_TYPE_UNKNOWN = "VENDOR_TYPE_UNKNOWN",
  /**
   * Энвайро
   */
  ENVIRO = "ENVIRO",
  /**
   * Лартех
   */
  LARTECH = "LARTECH",
  /**
   * РТК
   */
  RTK = "RTK",
}
/**
 * Посредники получения показаний
 */
export type TemplateIndicatorVendorTypeResponseEnum = keyof typeof TemplateIndicatorVendorType
/**
 * Посредники получения показаний
 */
export type TemplateIndicatorVendorTypeRequestEnum = Exclude<TemplateIndicatorVendorTypeResponseEnum, "VENDOR_TYPE_UNKNOWN">;

/**
 * Справочник типов направлений сортировки
 */
export enum TemplateIndicatorPagingDirectionType {
  /**
   * Значение не указано
   */
  DIRECTION_TYPE_UNKNOWN = "DIRECTION_TYPE_UNKNOWN",
  /**
   * От большего к меньшему
   */
  DESC = "DESC",
  /**
   * От меньшего к большему
   */
  ASC = "ASC",
}
/**
 * Справочник типов направлений сортировки
 */
export type TemplateIndicatorPagingDirectionTypeResponseEnum = keyof typeof TemplateIndicatorPagingDirectionType
/**
 * Справочник типов направлений сортировки
 */
export type TemplateIndicatorPagingDirectionTypeRequestEnum = Exclude<TemplateIndicatorPagingDirectionTypeResponseEnum, "DIRECTION_TYPE_UNKNOWN">;

/**
 * Справочник типов значений сортировки
 */
export enum TemplateIndicatorPagingOrderByType {
  /**
   * Значение не указано
   */
  ORDER_BY_TYPE_UNKNOWN = "ORDER_BY_TYPE_UNKNOWN",
  /**
   * По идентификатору
   */
  ID = "ID",
  /**
   * По типу измерений
   */
  SIGN_TYPE = "SIGN_TYPE",
  /**
   * По типу архивности показаний
   */
  ARCHIVE_TYPE = "ARCHIVE_TYPE",
}
/**
 * Справочник типов значений сортировки
 */
export type TemplateIndicatorPagingOrderByTypeResponseEnum = keyof typeof TemplateIndicatorPagingOrderByType
/**
 * Справочник типов значений сортировки
 */
export type TemplateIndicatorPagingOrderByTypeRequestEnum = Exclude<TemplateIndicatorPagingOrderByTypeResponseEnum, "ORDER_BY_TYPE_UNKNOWN">;

/**
 * Запрос удаления шаблона ПУ
 */
export type DeleteTemplateDeviceRequestDto = {
  /**
   * Идентификатор
   */
  id: number
}
/**
 * Ответ на запрос удаления шаблона ПУ
 */
export type DeleteTemplateDeviceResponseDto = {
}
/**
 * Запрос удаления шаблона индикатора
 */
export type DeleteTemplateIndicatorRequestDto = {
  /**
   * Идентификатор
   */
  id: number
}
/**
 * Ответ на запрос удаления шаблона индикатора
 */
export type DeleteTemplateIndicatorResponseDto = {
}
/**
 * Запрос получения количества шаблонов приборов учета
 */
export type GetTemplateDeviceCountRequestDto = {
  /**
   * Фильтр по шаблонам приборов учета
   */
  filter?: TemplateDeviceFilterRequestDto | null
}
/**
 * Ответ на запрос получения количества шаблонов приборов учета
 */
export type GetTemplateDeviceCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Всего шаблонов приборов учета
   */
  readonly data: number
  /**
   * Ошибка
   */
  readonly error: GetTemplateDeviceCountResponseErrorDto
}>
/**
 * Ошибка запроса получения количества шаблонов приборов учета
 */
export type GetTemplateDeviceCountResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка фильтрации
   */
  readonly templateDeviceFilterValidation: TemplateDeviceFilterValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения количества шаблонов приборов учета
 */
export type GetTemplateDeviceCountResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка фильтрации
   */
  readonly templateDeviceFilterValidation: TemplateDeviceFilterValidationErrorResponseDto
}>
/**
 * Запрос получения списка шаблонов ПУ
 */
export type GetTemplateDeviceListRequestDto = {
  /**
   * Фильтр
   */
  filter?: TemplateDeviceFilterRequestDto | null
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Пагинация
   */
  readonly paging: TemplateDevicePagingRequestDto
}>
/**
 * Ответ на запрос получения списка шаблонов приборов учета
 */
export type GetTemplateDeviceListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Шаблон ПУ
   */
  readonly data: TemplateDeviceResponseDto
  /**
   * Ошибка
   */
  readonly error: GetTemplateDeviceListResponseErrorDto
}>
/**
 * Ошибка запроса получения списка шаблонов приборов учета
 */
export type GetTemplateDeviceListResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка фильтрации
   */
  readonly templateDeviceFilterValidation: TemplateDeviceFilterValidationErrorRequestDto
  /**
   * Ошибка пагинации  по страницам
   */
  readonly templateDevicePagingValidation: TemplateDevicePagingValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения списка шаблонов приборов учета
 */
export type GetTemplateDeviceListResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка фильтрации
   */
  readonly templateDeviceFilterValidation: TemplateDeviceFilterValidationErrorResponseDto
  /**
   * Ошибка пагинации  по страницам
   */
  readonly templateDevicePagingValidation: TemplateDevicePagingValidationErrorResponseDto
}>
/**
 * Запрос получения шаблона ПУ
 */
export type GetTemplateDeviceRequestDto = {
  /**
   * Идентификатор шаблона ПУ
   */
  id: number
}
/**
 * Ответ на запрос получения шаблона ПУ
 */
export type GetTemplateDeviceResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Шаблон ПУ
   */
  readonly data: TemplateDeviceResponseDto
}>
/**
 * Запрос получения количества шаблонов индикаторов
 */
export type GetTemplateIndicatorCountRequestDto = {
  /**
   * Фильтр по шаблонам индикаторов
   */
  filter?: TemplateIndicatorFilterRequestDto | null
}
/**
 * Ответ на запрос получения количества шаблонов индикаторов
 */
export type GetTemplateIndicatorCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Всего шаблонов индикаторов
   */
  readonly data: number
  /**
   * Ошибка
   */
  readonly error: GetTemplateIndicatorCountResponseErrorDto
}>
/**
 * Ошибка запроса получения количества шаблонов индикаторов
 */
export type GetTemplateIndicatorCountResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка фильтрации
   */
  readonly templateIndicatorFilterValidation: TemplateIndicatorFilterValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения количества шаблонов индикаторов
 */
export type GetTemplateIndicatorCountResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка фильтрации
   */
  readonly templateIndicatorFilterValidation: TemplateIndicatorFilterValidationErrorResponseDto
}>
/**
 * Запрос получения списка шаблонов индикаторов
 */
export type GetTemplateIndicatorListRequestDto = {
  /**
   * Фильтр
   */
  filter?: TemplateIndicatorFilterRequestDto | null
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Пагинация
   */
  readonly paging: TemplateIndicatorPagingRequestDto
}>
/**
 * Ответ на запрос получения списка шаблонов индикаторов
 */
export type GetTemplateIndicatorListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Шаблон индикатора
   */
  readonly data: TemplateIndicatorResponseDto
  /**
   * Ошибка
   */
  readonly error: GetTemplateIndicatorListResponseErrorDto
}>
/**
 * Ошибка запроса получения списка шаблонов индикаторов
 */
export type GetTemplateIndicatorListResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка фильтрации
   */
  readonly templateIndicatorFilterValidation: TemplateIndicatorFilterValidationErrorRequestDto
  /**
   * Ошибка пагинации  по страницам
   */
  readonly templateIndicatorPagingValidation: TemplateIndicatorPagingValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения списка шаблонов индикаторов
 */
export type GetTemplateIndicatorListResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка фильтрации
   */
  readonly templateIndicatorFilterValidation: TemplateIndicatorFilterValidationErrorResponseDto
  /**
   * Ошибка пагинации  по страницам
   */
  readonly templateIndicatorPagingValidation: TemplateIndicatorPagingValidationErrorResponseDto
}>
/**
 * Запрос получения шаблона шаблона индикатора
 */
export type GetTemplateIndicatorRequestDto = {
  /**
   * Идентификатор шаблона индикатора
   */
  id: number
}
/**
 * Ответ на запрос получения шаблона индикатора
 */
export type GetTemplateIndicatorResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Шаблон ндикатора
   */
  readonly data: TemplateIndicatorResponseDto
}>
/**
 * Запрос сохранения шаблона ПУ
 */
export type PostTemplateDeviceRequestDto = {
  /**
   * Шаблон ПУ
   */
  data: TemplateDeviceRequestDto
}
/**
 * Ответ на запрос сохранения шаблона ПУ
 */
export type PostTemplateDeviceResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Шаблон ПУ
   */
  readonly data: TemplateDeviceResponseDto
  /**
   * Ошибка
   */
  readonly error: PostTemplateDeviceResponseErrorDto
}>
/**
 * Ошибка запроса сохранения шаблона ПУ
 */
export type PostTemplateDeviceResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: TemplateDeviceValidationErrorRequestDto
}>
/**
 * Ошибка запроса сохранения шаблона ПУ
 */
export type PostTemplateDeviceResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: TemplateDeviceValidationErrorResponseDto
}>
/**
 * Запрос сохранения шаблона индикатора
 */
export type PostTemplateIndicatorRequestDto = {
  /**
   * Шаблон индикатора
   */
  data: TemplateIndicatorRequestDto
}
/**
 * Ответ на запрос сохранения шаблона индикатора
 */
export type PostTemplateIndicatorResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Шаблон индикатора
   */
  readonly data: TemplateIndicatorResponseDto
  /**
   * Ошибка
   */
  readonly error: PostTemplateIndicatorResponseErrorDto
}>
/**
 * Ошибка запроса сохранения шаблона индикатора
 */
export type PostTemplateIndicatorResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: TemplateIndicatorValidationErrorRequestDto
}>
/**
 * Ошибка запроса сохранения шаблона индикатора
 */
export type PostTemplateIndicatorResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: TemplateIndicatorValidationErrorResponseDto
}>
/**
 * Шаблон ПУ
 */
export type TemplateDeviceRequestDto = {
  /**
   * Идентификатор
   */
  id?: number
  /**
   * Тип энергоресурса
   */
  metricType: TemplateDeviceMetricTypeRequestEnum
  /**
   * ID Модели счетчика
   */
  modelId?: number
  /**
   * Шаблоны индикаторов
   */
  indicatorTemplateIds?: number[]
  /**
   * Тип тарифного плана.
   * Для ПУ электроэнергии
   */
  planType?: TemplateDevicePlanTypeRequestEnum | "PLAN_TYPE_UNKNOWN"
  /**
   * Посредник получения показаний
   */
  indicatorVendorType?: TemplateIndicatorVendorTypeRequestEnum | "VENDOR_TYPE_UNKNOWN"
}
/**
 * Шаблон ПУ
 */
export type TemplateDeviceResponseDto = {
  /**
   * Идентификатор
   */
  id: number
  /**
   * Дата создания
   */
  readonly createdAt: string
  /**
   * Дата последнего изменения.
   * Заполняется и обновляется сервером.
   * Заполняется при создании и изменении
   */
  readonly changedAt: string
  /**
   * Тип энергоресурса
   */
  metricType: TemplateDeviceMetricTypeResponseEnum
  /**
   * ID Модели счетчика
   */
  modelId: number
  /**
   * Шаблоны индикаторов
   */
  indicatorTemplateIds: number[]
  /**
   * Тип тарифного плана.
   * Для ПУ электроэнергии
   */
  planType: TemplateDevicePlanTypeResponseEnum
  /**
   * Посредник получения показаний
   */
  indicatorVendorType: TemplateIndicatorVendorTypeResponseEnum
}
/**
 * Ошибки валидации.
 * Эти проверки выполняются до обращения в базу данных
 */
export type TemplateDeviceValidationErrorRequestDto = {
  /**
   * Путь к полю в формате наименования protobuf
   */
  path: string
  /**
   * Валидационное сообщение
   */
  message: string
}
/**
 * Ошибки валидации.
 * Эти проверки выполняются до обращения в базу данных
 */
export type TemplateDeviceValidationErrorResponseDto = {
  /**
   * Путь к полю в формате наименования protobuf
   */
  path: string
  /**
   * Валидационное сообщение
   */
  message: string
}
/**
 * Фильтр для запроса шаблонов приборов учета.
 * При передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.
 * При передаче нескольких разных параметров фильтра они работают в выборке через И
 */
export type TemplateDeviceFilterRequestDto = {
  /**
   * По типу энергоресурса
   */
  metricTypes?: TemplateDeviceMetricTypeResponseEnum[]
  /**
   * По ID модели счетчика
   */
  modelIds?: number[]
  /**
   * По типу тарифного плана. Для ПУ электроэнергии
   */
  planTypes?: TemplateDevicePlanTypeResponseEnum[]
  /**
   * По посреднику получения показаний
   */
  indicatorVendorTypes?: TemplateIndicatorVendorTypeResponseEnum[]
}
/**
 * Фильтр для запроса шаблонов приборов учета.
 * При передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.
 * При передаче нескольких разных параметров фильтра они работают в выборке через И
 */
export type TemplateDeviceFilterResponseDto = {
  /**
   * По типу энергоресурса
   */
  metricTypes: TemplateDeviceMetricTypeResponseEnum[]
  /**
   * По ID модели счетчика
   */
  modelIds: number[]
  /**
   * По типу тарифного плана. Для ПУ электроэнергии
   */
  planTypes: TemplateDevicePlanTypeResponseEnum[]
  /**
   * По посреднику получения показаний
   */
  indicatorVendorTypes: TemplateIndicatorVendorTypeResponseEnum[]
}
/**
 * Ошибки валидации.
 * Эти проверки выполняются до обращения в базу данных
 */
export type TemplateDeviceFilterValidationErrorRequestDto = {
  /**
   * Путь к полю в формате наименования protobuf
   */
  path: string
  /**
   * Валидационное сообщение
   */
  message: string
}
/**
 * Ошибки валидации.
 * Эти проверки выполняются до обращения в базу данных
 */
export type TemplateDeviceFilterValidationErrorResponseDto = {
  /**
   * Путь к полю в формате наименования protobuf
   */
  path: string
  /**
   * Валидационное сообщение
   */
  message: string
}
/**
 * Пагинация
 */
export type TemplateDevicePagingRequestDto = {
  /**
   * Тип значения сортировки.
   * По умолчанию: ID
   */
  orderByType?: TemplateDevicePagingOrderByTypeRequestEnum | "ORDER_BY_TYPE_UNKNOWN"
  /**
   * Тип направления сортировки.
   * По умолчанию: DESC
   */
  directionType?: TemplateDevicePagingDirectionTypeRequestEnum | "DIRECTION_TYPE_UNKNOWN"
  /**
   * Количество.
   * Минимальное значение: 1.
   * Максимальное значение: 100.
   * По умолчанию: 20.
   * Если значение 0 (не передано) то выставляем значение по умолчанию
   */
  limit?: number
  /**
   * Сдвиг.
   * По умолчанию: 0
   */
  offset?: number
}
/**
 * Пагинация
 */
export type TemplateDevicePagingResponseDto = {
  /**
   * Тип значения сортировки.
   * По умолчанию: ID
   */
  orderByType: TemplateDevicePagingOrderByTypeResponseEnum
  /**
   * Тип направления сортировки.
   * По умолчанию: DESC
   */
  directionType: TemplateDevicePagingDirectionTypeResponseEnum
  /**
   * Количество.
   * Минимальное значение: 1.
   * Максимальное значение: 100.
   * По умолчанию: 20.
   * Если значение 0 (не передано) то выставляем значение по умолчанию
   */
  limit: number
  /**
   * Сдвиг.
   * По умолчанию: 0
   */
  offset: number
}
/**
 * Ошибка валидации постраничной пагинации по шаблонам ПУ.
 * Эти проверки выполняются до обращения в базу данных
 */
export type TemplateDevicePagingValidationErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Количество передано некорректно
   */
  readonly limit: TemplateDevicePagingValidationErrorLimitInvalidRequestDto
  /**
   * Сдвиг передан некорректно
   */
  readonly offset: TemplateDevicePagingValidationErrorOffsetInvalidRequestDto
}>
/**
 * Ошибка валидации постраничной пагинации по шаблонам ПУ.
 * Эти проверки выполняются до обращения в базу данных
 */
export type TemplateDevicePagingValidationErrorResponseDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Количество передано некорректно
   */
  readonly limit: TemplateDevicePagingValidationErrorLimitInvalidResponseDto
  /**
   * Сдвиг передан некорректно
   */
  readonly offset: TemplateDevicePagingValidationErrorOffsetInvalidResponseDto
}>
/**
 * Причины:
 * - Значение количества < 0 или > 100
 */
export type TemplateDevicePagingValidationErrorLimitInvalidRequestDto = {
}
/**
 * Причины:
 * - Значение количества < 0 или > 100
 */
export type TemplateDevicePagingValidationErrorLimitInvalidResponseDto = {
}
/**
 * Причины:
 * - Значение сдвига < 0
 */
export type TemplateDevicePagingValidationErrorOffsetInvalidRequestDto = {
}
/**
 * Причины:
 * - Значение сдвига < 0
 */
export type TemplateDevicePagingValidationErrorOffsetInvalidResponseDto = {
}
/**
 * Шаблон индикатора
 */
export type TemplateIndicatorRequestDto = {
  /**
   * Идентификатор
   */
  id?: number
  /**
   * Шаблонное название индикатора
   */
  title: string
  /**
   * Тип единицы измерения, в которой интерпретировано, получаемое измерение
   */
  unitType: TemplateIndicatorUnitTypeRequestEnum
  /**
   * Тип измерения
   */
  signType: TemplateIndicatorSignTypeRequestEnum
  /**
   * Тип архивности показаний
   */
  archiveType?: TemplateIndicatorArchiveTypeRequestEnum | "ARCHIVE_TYPE_UNKNOWN"
  /**
   * Тип единицы измерения для отображения измерения.
   * При UNIT_TYPE_UNKNOWN отображаемые единицы совпадают с единицами источников значений, преобразования единиц не происходит.
   * Применяется после коэффициента
   */
  presentationUnitType?: TemplateIndicatorUnitTypeRequestEnum | "UNIT_TYPE_UNKNOWN"
  /**
   * Код для совместимости с поставщиком метрик
   */
  compatibilityCode?: string | null
  /**
   * Флаг видимости индикатора для клиента ФЛ
   */
  isIndividual?: boolean
  /**
   * Коэффициент, на который умножается отображаемое значение.
   * Применяется перед преобразованием единиц измерений к presentation_unit_type и после применения поправки
   */
  coefficient?: number | null
  /**
   * Величина поправки к отображаемому значению.
   * Применяется перед применением коэффициента
   */
  shift?: number | null
  /**
   * Количество возвращаемых десятичных знаков при округлении итогового значения.
   * При пустом параметре округления не происходит.
   * Применяется после преобразования единиц измерения
   */
  roundDecimalDigits?: number | null
  /**
   * Ожидаемая частота поступления показаний в днях
   */
  metricExpectedFreq?: number
  /**
   * Посредник получения показаний
   */
  indicatorVendorType?: TemplateIndicatorVendorTypeRequestEnum | "VENDOR_TYPE_UNKNOWN"
}
/**
 * Шаблон индикатора
 */
export type TemplateIndicatorResponseDto = {
  /**
   * Идентификатор
   */
  id: number
  /**
   * Дата создания
   */
  readonly createdAt: string
  /**
   * Дата последнего изменения.
   * Заполняется и обновляется сервером.
   * Заполняется при создании и изменении
   */
  readonly changedAt: string
  /**
   * Шаблонное название индикатора
   */
  title: string
  /**
   * Тип единицы измерения, в которой интерпретировано, получаемое измерение
   */
  unitType: TemplateIndicatorUnitTypeResponseEnum
  /**
   * Тип измерения
   */
  signType: TemplateIndicatorSignTypeResponseEnum
  /**
   * Тип архивности показаний
   */
  archiveType: TemplateIndicatorArchiveTypeResponseEnum
  /**
   * Тип единицы измерения для отображения измерения.
   * При UNIT_TYPE_UNKNOWN отображаемые единицы совпадают с единицами источников значений, преобразования единиц не происходит.
   * Применяется после коэффициента
   */
  presentationUnitType: TemplateIndicatorUnitTypeResponseEnum
  /**
   * Код для совместимости с поставщиком метрик
   */
  compatibilityCode: string | null
  /**
   * Флаг видимости индикатора для клиента ФЛ
   */
  isIndividual: boolean
  /**
   * Коэффициент, на который умножается отображаемое значение.
   * Применяется перед преобразованием единиц измерений к presentation_unit_type и после применения поправки
   */
  coefficient: number | null
  /**
   * Величина поправки к отображаемому значению.
   * Применяется перед применением коэффициента
   */
  shift: number | null
  /**
   * Количество возвращаемых десятичных знаков при округлении итогового значения.
   * При пустом параметре округления не происходит.
   * Применяется после преобразования единиц измерения
   */
  roundDecimalDigits: number | null
  /**
   * Ожидаемая частота поступления показаний в днях
   */
  metricExpectedFreq: number
  /**
   * Посредник получения показаний
   */
  indicatorVendorType: TemplateIndicatorVendorTypeResponseEnum
}
/**
 * Ошибки валидации.
 * Эти проверки выполняются до обращения в базу данных
 */
export type TemplateIndicatorValidationErrorRequestDto = {
  /**
   * Путь к полю в формате наименования protobuf
   */
  path: string
  /**
   * Валидационное сообщение
   */
  message: string
}
/**
 * Ошибки валидации.
 * Эти проверки выполняются до обращения в базу данных
 */
export type TemplateIndicatorValidationErrorResponseDto = {
  /**
   * Путь к полю в формате наименования protobuf
   */
  path: string
  /**
   * Валидационное сообщение
   */
  message: string
}
/**
 * Фильтр для запроса шаблонов индикаторов.
 * При передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.
 * При передаче нескольких разных параметров фильтра они работают в выборке через И
 */
export type TemplateIndicatorFilterRequestDto = {
  /**
   * По типу измерений
   */
  signTypes?: TemplateIndicatorSignTypeResponseEnum[]
  /**
   * По типу архивности показаний
   */
  archiveTypes?: TemplateIndicatorArchiveTypeResponseEnum[]
  /**
   * По флагу видимости индикатора для клиента ФЛ
   */
  isIndividual?: boolean | null
  /**
   * По шаблонному названию индикатора.
   * Поиск производится по подстроке
   */
  title?: string | null
  /**
   * По посреднику получения показаний
   */
  indicatorVendorTypes?: TemplateIndicatorVendorTypeResponseEnum[]
}
/**
 * Фильтр для запроса шаблонов индикаторов.
 * При передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.
 * При передаче нескольких разных параметров фильтра они работают в выборке через И
 */
export type TemplateIndicatorFilterResponseDto = {
  /**
   * По типу измерений
   */
  signTypes: TemplateIndicatorSignTypeResponseEnum[]
  /**
   * По типу архивности показаний
   */
  archiveTypes: TemplateIndicatorArchiveTypeResponseEnum[]
  /**
   * По флагу видимости индикатора для клиента ФЛ
   */
  isIndividual: boolean | null
  /**
   * По шаблонному названию индикатора.
   * Поиск производится по подстроке
   */
  title: string | null
  /**
   * По посреднику получения показаний
   */
  indicatorVendorTypes: TemplateIndicatorVendorTypeResponseEnum[]
}
/**
 * Ошибки валидации.
 * Эти проверки выполняются до обращения в базу данных
 */
export type TemplateIndicatorFilterValidationErrorRequestDto = {
  /**
   * Путь к полю в формате наименования protobuf
   */
  path: string
  /**
   * Валидационное сообщение
   */
  message: string
}
/**
 * Ошибки валидации.
 * Эти проверки выполняются до обращения в базу данных
 */
export type TemplateIndicatorFilterValidationErrorResponseDto = {
  /**
   * Путь к полю в формате наименования protobuf
   */
  path: string
  /**
   * Валидационное сообщение
   */
  message: string
}
/**
 * Пагинация
 */
export type TemplateIndicatorPagingRequestDto = {
  /**
   * Тип значения сортировки.
   * По умолчанию: ID
   */
  orderByType?: TemplateIndicatorPagingOrderByTypeRequestEnum | "ORDER_BY_TYPE_UNKNOWN"
  /**
   * Тип направления сортировки.
   * По умолчанию: DESC
   */
  directionType?: TemplateIndicatorPagingDirectionTypeRequestEnum | "DIRECTION_TYPE_UNKNOWN"
  /**
   * Количество.
   * Минимальное значение: 1.
   * Максимальное значение: 100.
   * По умолчанию: 20.
   * Если значение 0 (не передано) то выставляем значение по умолчанию
   */
  limit?: number
  /**
   * Сдвиг.
   * По умолчанию: 0
   */
  offset?: number
}
/**
 * Пагинация
 */
export type TemplateIndicatorPagingResponseDto = {
  /**
   * Тип значения сортировки.
   * По умолчанию: ID
   */
  orderByType: TemplateIndicatorPagingOrderByTypeResponseEnum
  /**
   * Тип направления сортировки.
   * По умолчанию: DESC
   */
  directionType: TemplateIndicatorPagingDirectionTypeResponseEnum
  /**
   * Количество.
   * Минимальное значение: 1.
   * Максимальное значение: 100.
   * По умолчанию: 20.
   * Если значение 0 (не передано) то выставляем значение по умолчанию
   */
  limit: number
  /**
   * Сдвиг.
   * По умолчанию: 0
   */
  offset: number
}
/**
 * Ошибка валидации постраничной пагинации по шаблонам индикатора.
 * Эти проверки выполняются до обращения в базу данных
 */
export type TemplateIndicatorPagingValidationErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Количество передано некорректно
   */
  readonly limit: TemplateIndicatorPagingValidationErrorLimitInvalidRequestDto
  /**
   * Сдвиг передан некорректно
   */
  readonly offset: TemplateIndicatorPagingValidationErrorOffsetInvalidRequestDto
}>
/**
 * Ошибка валидации постраничной пагинации по шаблонам индикатора.
 * Эти проверки выполняются до обращения в базу данных
 */
export type TemplateIndicatorPagingValidationErrorResponseDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Количество передано некорректно
   */
  readonly limit: TemplateIndicatorPagingValidationErrorLimitInvalidResponseDto
  /**
   * Сдвиг передан некорректно
   */
  readonly offset: TemplateIndicatorPagingValidationErrorOffsetInvalidResponseDto
}>
/**
 * Причины:
 * - Значение количества < 0 или > 100
 */
export type TemplateIndicatorPagingValidationErrorLimitInvalidRequestDto = {
}
/**
 * Причины:
 * - Значение количества < 0 или > 100
 */
export type TemplateIndicatorPagingValidationErrorLimitInvalidResponseDto = {
}
/**
 * Причины:
 * - Значение сдвига < 0
 */
export type TemplateIndicatorPagingValidationErrorOffsetInvalidRequestDto = {
}
/**
 * Причины:
 * - Значение сдвига < 0
 */
export type TemplateIndicatorPagingValidationErrorOffsetInvalidResponseDto = {
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос удаления шаблона ПУ
   */
  "DeleteTemplateDeviceRequest": {
    "kind": "class",
    "text": "Запрос удаления шаблона ПУ",
    "fields": {
      /**
       * Идентификатор
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос удаления шаблона ПУ
   */
  "DeleteTemplateDeviceResponse": {
    "kind": "class",
    "text": "Ответ на запрос удаления шаблона ПУ",
  },
  /**
   * Запрос удаления шаблона индикатора
   */
  "DeleteTemplateIndicatorRequest": {
    "kind": "class",
    "text": "Запрос удаления шаблона индикатора",
    "fields": {
      /**
       * Идентификатор
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос удаления шаблона индикатора
   */
  "DeleteTemplateIndicatorResponse": {
    "kind": "class",
    "text": "Ответ на запрос удаления шаблона индикатора",
  },
  /**
   * Запрос получения количества шаблонов приборов учета
   */
  "GetTemplateDeviceCountRequest": {
    "kind": "class",
    "text": "Запрос получения количества шаблонов приборов учета",
    "fields": {
      /**
       * Фильтр по шаблонам приборов учета
       */
      "filter": {
        "type": "TemplateDeviceFilter",
        "text": "Фильтр по шаблонам приборов учета",
      },
    },
  },
  /**
   * Ответ на запрос получения количества шаблонов приборов учета
   */
  "GetTemplateDeviceCountResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения количества шаблонов приборов учета",
    "fields": {
      /**
       * Всего шаблонов приборов учета
       */
      "data": {
        "type": "int32",
        "text": "Всего шаблонов приборов учета",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetTemplateDeviceCountResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения количества шаблонов приборов учета
   */
  "GetTemplateDeviceCountResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения количества шаблонов приборов учета",
    "fields": {
      /**
       * Ошибка фильтрации
       */
      "templateDeviceFilterValidation": {
        "type": "TemplateDeviceFilter.ValidationError",
        "text": "Ошибка фильтрации",
      },
    },
  },
  /**
   * Запрос получения списка шаблонов ПУ
   */
  "GetTemplateDeviceListRequest": {
    "kind": "class",
    "text": "Запрос получения списка шаблонов ПУ",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "TemplateDeviceFilter",
        "text": "Фильтр",
      },
      /**
       * Пагинация
       */
      "paging": {
        "type": "TemplateDevicePaging",
        "text": "Пагинация",
      },
    },
  },
  /**
   * Ответ на запрос получения списка шаблонов приборов учета
   */
  "GetTemplateDeviceListResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения списка шаблонов приборов учета",
    "fields": {
      /**
       * Шаблон ПУ
       */
      "data": {
        "type": "TemplateDevice",
        "text": "Шаблон ПУ",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetTemplateDeviceListResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения списка шаблонов приборов учета
   */
  "GetTemplateDeviceListResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения списка шаблонов приборов учета",
    "fields": {
      /**
       * Ошибка фильтрации
       */
      "templateDeviceFilterValidation": {
        "type": "TemplateDeviceFilter.ValidationError",
        "text": "Ошибка фильтрации",
      },
      /**
       * Ошибка пагинации  по страницам
       */
      "templateDevicePagingValidation": {
        "type": "TemplateDevicePaging.ValidationError",
        "text": "Ошибка пагинации  по страницам",
      },
    },
  },
  /**
   * Запрос получения шаблона ПУ
   */
  "GetTemplateDeviceRequest": {
    "kind": "class",
    "text": "Запрос получения шаблона ПУ",
    "fields": {
      /**
       * Идентификатор шаблона ПУ
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор шаблона ПУ",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос получения шаблона ПУ
   */
  "GetTemplateDeviceResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения шаблона ПУ",
    "fields": {
      /**
       * Шаблон ПУ
       */
      "data": {
        "type": "TemplateDevice",
        "text": "Шаблон ПУ",
      },
    },
  },
  /**
   * Запрос получения количества шаблонов индикаторов
   */
  "GetTemplateIndicatorCountRequest": {
    "kind": "class",
    "text": "Запрос получения количества шаблонов индикаторов",
    "fields": {
      /**
       * Фильтр по шаблонам индикаторов
       */
      "filter": {
        "type": "TemplateIndicatorFilter",
        "text": "Фильтр по шаблонам индикаторов",
      },
    },
  },
  /**
   * Ответ на запрос получения количества шаблонов индикаторов
   */
  "GetTemplateIndicatorCountResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения количества шаблонов индикаторов",
    "fields": {
      /**
       * Всего шаблонов индикаторов
       */
      "data": {
        "type": "int32",
        "text": "Всего шаблонов индикаторов",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetTemplateIndicatorCountResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения количества шаблонов индикаторов
   */
  "GetTemplateIndicatorCountResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения количества шаблонов индикаторов",
    "fields": {
      /**
       * Ошибка фильтрации
       */
      "templateIndicatorFilterValidation": {
        "type": "TemplateIndicatorFilter.ValidationError",
        "text": "Ошибка фильтрации",
      },
    },
  },
  /**
   * Запрос получения списка шаблонов индикаторов
   */
  "GetTemplateIndicatorListRequest": {
    "kind": "class",
    "text": "Запрос получения списка шаблонов индикаторов",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "TemplateIndicatorFilter",
        "text": "Фильтр",
      },
      /**
       * Пагинация
       */
      "paging": {
        "type": "TemplateIndicatorPaging",
        "text": "Пагинация",
      },
    },
  },
  /**
   * Ответ на запрос получения списка шаблонов индикаторов
   */
  "GetTemplateIndicatorListResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения списка шаблонов индикаторов",
    "fields": {
      /**
       * Шаблон индикатора
       */
      "data": {
        "type": "TemplateIndicator",
        "text": "Шаблон индикатора",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetTemplateIndicatorListResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения списка шаблонов индикаторов
   */
  "GetTemplateIndicatorListResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения списка шаблонов индикаторов",
    "fields": {
      /**
       * Ошибка фильтрации
       */
      "templateIndicatorFilterValidation": {
        "type": "TemplateIndicatorFilter.ValidationError",
        "text": "Ошибка фильтрации",
      },
      /**
       * Ошибка пагинации  по страницам
       */
      "templateIndicatorPagingValidation": {
        "type": "TemplateIndicatorPaging.ValidationError",
        "text": "Ошибка пагинации  по страницам",
      },
    },
  },
  /**
   * Запрос получения шаблона шаблона индикатора
   */
  "GetTemplateIndicatorRequest": {
    "kind": "class",
    "text": "Запрос получения шаблона шаблона индикатора",
    "fields": {
      /**
       * Идентификатор шаблона индикатора
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор шаблона индикатора",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос получения шаблона индикатора
   */
  "GetTemplateIndicatorResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения шаблона индикатора",
    "fields": {
      /**
       * Шаблон ндикатора
       */
      "data": {
        "type": "TemplateIndicator",
        "text": "Шаблон ндикатора",
      },
    },
  },
  /**
   * Запрос сохранения шаблона ПУ
   */
  "PostTemplateDeviceRequest": {
    "kind": "class",
    "text": "Запрос сохранения шаблона ПУ",
    "fields": {
      /**
       * Шаблон ПУ
       */
      "data": {
        "type": "TemplateDevice",
        "text": "Шаблон ПУ",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос сохранения шаблона ПУ
   */
  "PostTemplateDeviceResponse": {
    "kind": "class",
    "text": "Ответ на запрос сохранения шаблона ПУ",
    "fields": {
      /**
       * Шаблон ПУ
       */
      "data": {
        "type": "TemplateDevice",
        "text": "Шаблон ПУ",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "PostTemplateDeviceResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса сохранения шаблона ПУ
   */
  "PostTemplateDeviceResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса сохранения шаблона ПУ",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "TemplateDevice.ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос сохранения шаблона индикатора
   */
  "PostTemplateIndicatorRequest": {
    "kind": "class",
    "text": "Запрос сохранения шаблона индикатора",
    "fields": {
      /**
       * Шаблон индикатора
       */
      "data": {
        "type": "TemplateIndicator",
        "text": "Шаблон индикатора",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос сохранения шаблона индикатора
   */
  "PostTemplateIndicatorResponse": {
    "kind": "class",
    "text": "Ответ на запрос сохранения шаблона индикатора",
    "fields": {
      /**
       * Шаблон индикатора
       */
      "data": {
        "type": "TemplateIndicator",
        "text": "Шаблон индикатора",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "PostTemplateIndicatorResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса сохранения шаблона индикатора
   */
  "PostTemplateIndicatorResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса сохранения шаблона индикатора",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "TemplateIndicator.ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Шаблон ПУ
   */
  "TemplateDevice": {
    "kind": "class",
    "text": "Шаблон ПУ",
    "fields": {
      /**
       * Идентификатор
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор",
      },
      /**
       * Дата создания
       */
      "createdAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата создания",
      },
      /**
       * Дата последнего изменения.
       * Заполняется и обновляется сервером.
       * Заполняется при создании и изменении
       */
      "changedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата последнего изменения.\nЗаполняется и обновляется сервером.\nЗаполняется при создании и изменении",
      },
      /**
       * Тип энергоресурса
       */
      "metricType": {
        "type": "TemplateDevice.MetricType",
        "text": "Тип энергоресурса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * ID Модели счетчика
       */
      "modelId": {
        "type": "int32",
        "text": "ID Модели счетчика",
      },
      /**
       * Шаблоны индикаторов
       */
      "indicatorTemplateIds": {
        "type": "int32",
        "text": "Шаблоны индикаторов",
      },
      /**
       * Тип тарифного плана.
       * Для ПУ электроэнергии
       */
      "planType": {
        "type": "TemplateDevice.PlanType",
        "text": "Тип тарифного плана.\nДля ПУ электроэнергии",
      },
      /**
       * Посредник получения показаний
       */
      "indicatorVendorType": {
        "type": "TemplateIndicator.VendorType",
        "text": "Посредник получения показаний",
      },
    },
  },
  /**
   * Ошибки валидации.
   * Эти проверки выполняются до обращения в базу данных
   */
  "TemplateDevice.ValidationError": {
    "kind": "class",
    "text": "Ошибки валидации.\nЭти проверки выполняются до обращения в базу данных",
    "fields": {
      /**
       * Путь к полю в формате наименования protobuf
       */
      "path": {
        "type": "string",
        "text": "Путь к полю в формате наименования protobuf",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Валидационное сообщение
       */
      "message": {
        "type": "string",
        "text": "Валидационное сообщение",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Фильтр для запроса шаблонов приборов учета.
   * При передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.
   * При передаче нескольких разных параметров фильтра они работают в выборке через И
   */
  "TemplateDeviceFilter": {
    "kind": "class",
    "text": "Фильтр для запроса шаблонов приборов учета.\nПри передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.\nПри передаче нескольких разных параметров фильтра они работают в выборке через И",
    "fields": {
      /**
       * По типу энергоресурса
       */
      "metricTypes": {
        "type": "TemplateDevice.MetricType",
        "text": "По типу энергоресурса",
      },
      /**
       * По ID модели счетчика
       */
      "modelIds": {
        "type": "int32",
        "text": "По ID модели счетчика",
      },
      /**
       * По типу тарифного плана. Для ПУ электроэнергии
       */
      "planTypes": {
        "type": "TemplateDevice.PlanType",
        "text": "По типу тарифного плана. Для ПУ электроэнергии",
      },
      /**
       * По посреднику получения показаний
       */
      "indicatorVendorTypes": {
        "type": "TemplateIndicator.VendorType",
        "text": "По посреднику получения показаний",
      },
    },
  },
  /**
   * Ошибки валидации.
   * Эти проверки выполняются до обращения в базу данных
   */
  "TemplateDeviceFilter.ValidationError": {
    "kind": "class",
    "text": "Ошибки валидации.\nЭти проверки выполняются до обращения в базу данных",
    "fields": {
      /**
       * Путь к полю в формате наименования protobuf
       */
      "path": {
        "type": "string",
        "text": "Путь к полю в формате наименования protobuf",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Валидационное сообщение
       */
      "message": {
        "type": "string",
        "text": "Валидационное сообщение",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Пагинация
   */
  "TemplateDevicePaging": {
    "kind": "class",
    "text": "Пагинация",
    "fields": {
      /**
       * Тип значения сортировки.
       * По умолчанию: ID
       */
      "orderByType": {
        "type": "TemplateDevicePaging.OrderByType",
        "text": "Тип значения сортировки.\nПо умолчанию: ID",
      },
      /**
       * Тип направления сортировки.
       * По умолчанию: DESC
       */
      "directionType": {
        "type": "TemplateDevicePaging.DirectionType",
        "text": "Тип направления сортировки.\nПо умолчанию: DESC",
      },
      /**
       * Количество.
       * Минимальное значение: 1.
       * Максимальное значение: 100.
       * По умолчанию: 20.
       * Если значение 0 (не передано) то выставляем значение по умолчанию
       */
      "limit": {
        "type": "int32",
        "text": "Количество.\nМинимальное значение: 1.\nМаксимальное значение: 100.\nПо умолчанию: 20.\nЕсли значение 0 (не передано) то выставляем значение по умолчанию",
      },
      /**
       * Сдвиг.
       * По умолчанию: 0
       */
      "offset": {
        "type": "int32",
        "text": "Сдвиг.\nПо умолчанию: 0",
      },
    },
  },
  /**
   * Ошибка валидации постраничной пагинации по шаблонам ПУ.
   * Эти проверки выполняются до обращения в базу данных
   */
  "TemplateDevicePaging.ValidationError": {
    "kind": "class",
    "text": "Ошибка валидации постраничной пагинации по шаблонам ПУ.\nЭти проверки выполняются до обращения в базу данных",
    "fields": {
      /**
       * Количество передано некорректно
       */
      "limit": {
        "type": "TemplateDevicePaging.ValidationError.LimitInvalid",
        "text": "Количество передано некорректно",
      },
      /**
       * Сдвиг передан некорректно
       */
      "offset": {
        "type": "TemplateDevicePaging.ValidationError.OffsetInvalid",
        "text": "Сдвиг передан некорректно",
      },
    },
  },
  /**
   * Причины:
   * - Значение количества < 0 или > 100
   */
  "TemplateDevicePaging.ValidationError.LimitInvalid": {
    "kind": "class",
    "text": "Причины:\n- Значение количества < 0 или > 100",
  },
  /**
   * Причины:
   * - Значение сдвига < 0
   */
  "TemplateDevicePaging.ValidationError.OffsetInvalid": {
    "kind": "class",
    "text": "Причины:\n- Значение сдвига < 0",
  },
  /**
   * Шаблон индикатора
   */
  "TemplateIndicator": {
    "kind": "class",
    "text": "Шаблон индикатора",
    "fields": {
      /**
       * Идентификатор
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор",
      },
      /**
       * Дата создания
       */
      "createdAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата создания",
      },
      /**
       * Дата последнего изменения.
       * Заполняется и обновляется сервером.
       * Заполняется при создании и изменении
       */
      "changedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата последнего изменения.\nЗаполняется и обновляется сервером.\nЗаполняется при создании и изменении",
      },
      /**
       * Шаблонное название индикатора
       */
      "title": {
        "type": "string",
        "text": "Шаблонное название индикатора",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Тип единицы измерения, в которой интерпретировано, получаемое измерение
       */
      "unitType": {
        "type": "TemplateIndicator.UnitType",
        "text": "Тип единицы измерения, в которой интерпретировано, получаемое измерение",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Тип измерения
       */
      "signType": {
        "type": "TemplateIndicator.SignType",
        "text": "Тип измерения",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Тип архивности показаний
       */
      "archiveType": {
        "type": "TemplateIndicator.ArchiveType",
        "text": "Тип архивности показаний",
      },
      /**
       * Тип единицы измерения для отображения измерения.
       * При UNIT_TYPE_UNKNOWN отображаемые единицы совпадают с единицами источников значений, преобразования единиц не происходит.
       * Применяется после коэффициента
       */
      "presentationUnitType": {
        "type": "TemplateIndicator.UnitType",
        "text": "Тип единицы измерения для отображения измерения.\nПри UNIT_TYPE_UNKNOWN отображаемые единицы совпадают с единицами источников значений, преобразования единиц не происходит.\nПрименяется после коэффициента",
      },
      /**
       * Код для совместимости с поставщиком метрик
       */
      "compatibilityCode": {
        "type": "google.protobuf.StringValue",
        "text": "Код для совместимости с поставщиком метрик",
      },
      /**
       * Флаг видимости индикатора для клиента ФЛ
       */
      "isIndividual": {
        "type": "bool",
        "text": "Флаг видимости индикатора для клиента ФЛ",
      },
      /**
       * Коэффициент, на который умножается отображаемое значение.
       * Применяется перед преобразованием единиц измерений к presentation_unit_type и после применения поправки
       */
      "coefficient": {
        "type": "google.protobuf.FloatValue",
        "text": "Коэффициент, на который умножается отображаемое значение.\nПрименяется перед преобразованием единиц измерений к presentation_unit_type и после применения поправки",
      },
      /**
       * Величина поправки к отображаемому значению.
       * Применяется перед применением коэффициента
       */
      "shift": {
        "type": "google.protobuf.FloatValue",
        "text": "Величина поправки к отображаемому значению.\nПрименяется перед применением коэффициента",
      },
      /**
       * Количество возвращаемых десятичных знаков при округлении итогового значения.
       * При пустом параметре округления не происходит.
       * Применяется после преобразования единиц измерения
       */
      "roundDecimalDigits": {
        "type": "google.protobuf.Int32Value",
        "text": "Количество возвращаемых десятичных знаков при округлении итогового значения.\nПри пустом параметре округления не происходит.\nПрименяется после преобразования единиц измерения",
      },
      /**
       * Ожидаемая частота поступления показаний в днях
       */
      "metricExpectedFreq": {
        "type": "int32",
        "text": "Ожидаемая частота поступления показаний в днях",
      },
      /**
       * Посредник получения показаний
       */
      "indicatorVendorType": {
        "type": "TemplateIndicator.VendorType",
        "text": "Посредник получения показаний",
      },
    },
  },
  /**
   * Ошибки валидации.
   * Эти проверки выполняются до обращения в базу данных
   */
  "TemplateIndicator.ValidationError": {
    "kind": "class",
    "text": "Ошибки валидации.\nЭти проверки выполняются до обращения в базу данных",
    "fields": {
      /**
       * Путь к полю в формате наименования protobuf
       */
      "path": {
        "type": "string",
        "text": "Путь к полю в формате наименования protobuf",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Валидационное сообщение
       */
      "message": {
        "type": "string",
        "text": "Валидационное сообщение",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Фильтр для запроса шаблонов индикаторов.
   * При передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.
   * При передаче нескольких разных параметров фильтра они работают в выборке через И
   */
  "TemplateIndicatorFilter": {
    "kind": "class",
    "text": "Фильтр для запроса шаблонов индикаторов.\nПри передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.\nПри передаче нескольких разных параметров фильтра они работают в выборке через И",
    "fields": {
      /**
       * По типу измерений
       */
      "signTypes": {
        "type": "TemplateIndicator.SignType",
        "text": "По типу измерений",
      },
      /**
       * По типу архивности показаний
       */
      "archiveTypes": {
        "type": "TemplateIndicator.ArchiveType",
        "text": "По типу архивности показаний",
      },
      /**
       * По флагу видимости индикатора для клиента ФЛ
       */
      "isIndividual": {
        "type": "google.protobuf.BoolValue",
        "text": "По флагу видимости индикатора для клиента ФЛ",
      },
      /**
       * По шаблонному названию индикатора.
       * Поиск производится по подстроке
       */
      "title": {
        "type": "google.protobuf.StringValue",
        "text": "По шаблонному названию индикатора.\nПоиск производится по подстроке",
      },
      /**
       * По посреднику получения показаний
       */
      "indicatorVendorTypes": {
        "type": "TemplateIndicator.VendorType",
        "text": "По посреднику получения показаний",
      },
    },
  },
  /**
   * Ошибки валидации.
   * Эти проверки выполняются до обращения в базу данных
   */
  "TemplateIndicatorFilter.ValidationError": {
    "kind": "class",
    "text": "Ошибки валидации.\nЭти проверки выполняются до обращения в базу данных",
    "fields": {
      /**
       * Путь к полю в формате наименования protobuf
       */
      "path": {
        "type": "string",
        "text": "Путь к полю в формате наименования protobuf",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Валидационное сообщение
       */
      "message": {
        "type": "string",
        "text": "Валидационное сообщение",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Пагинация
   */
  "TemplateIndicatorPaging": {
    "kind": "class",
    "text": "Пагинация",
    "fields": {
      /**
       * Тип значения сортировки.
       * По умолчанию: ID
       */
      "orderByType": {
        "type": "TemplateIndicatorPaging.OrderByType",
        "text": "Тип значения сортировки.\nПо умолчанию: ID",
      },
      /**
       * Тип направления сортировки.
       * По умолчанию: DESC
       */
      "directionType": {
        "type": "TemplateIndicatorPaging.DirectionType",
        "text": "Тип направления сортировки.\nПо умолчанию: DESC",
      },
      /**
       * Количество.
       * Минимальное значение: 1.
       * Максимальное значение: 100.
       * По умолчанию: 20.
       * Если значение 0 (не передано) то выставляем значение по умолчанию
       */
      "limit": {
        "type": "int32",
        "text": "Количество.\nМинимальное значение: 1.\nМаксимальное значение: 100.\nПо умолчанию: 20.\nЕсли значение 0 (не передано) то выставляем значение по умолчанию",
      },
      /**
       * Сдвиг.
       * По умолчанию: 0
       */
      "offset": {
        "type": "int32",
        "text": "Сдвиг.\nПо умолчанию: 0",
      },
    },
  },
  /**
   * Ошибка валидации постраничной пагинации по шаблонам индикатора.
   * Эти проверки выполняются до обращения в базу данных
   */
  "TemplateIndicatorPaging.ValidationError": {
    "kind": "class",
    "text": "Ошибка валидации постраничной пагинации по шаблонам индикатора.\nЭти проверки выполняются до обращения в базу данных",
    "fields": {
      /**
       * Количество передано некорректно
       */
      "limit": {
        "type": "TemplateIndicatorPaging.ValidationError.LimitInvalid",
        "text": "Количество передано некорректно",
      },
      /**
       * Сдвиг передан некорректно
       */
      "offset": {
        "type": "TemplateIndicatorPaging.ValidationError.OffsetInvalid",
        "text": "Сдвиг передан некорректно",
      },
    },
  },
  /**
   * Причины:
   * - Значение количества < 0 или > 100
   */
  "TemplateIndicatorPaging.ValidationError.LimitInvalid": {
    "kind": "class",
    "text": "Причины:\n- Значение количества < 0 или > 100",
  },
  /**
   * Причины:
   * - Значение сдвига < 0
   */
  "TemplateIndicatorPaging.ValidationError.OffsetInvalid": {
    "kind": "class",
    "text": "Причины:\n- Значение сдвига < 0",
  },
  /**
   * Справочние типов энергоресурсов
   */
  "TemplateDevice.MetricType": {
    "kind": "enum",
    "text": "Справочние типов энергоресурсов",
    "values": {
      /**
       * Значение не указано
       */
      "METRIC_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Горячая вода
       */
      "HOT_WATER": {
        "i": 1,
        "text": "Горячая вода",
      },
      /**
       * Холодная вода
       */
      "COLD_WATER": {
        "i": 2,
        "text": "Холодная вода",
      },
      /**
       * Теплоэнергия
       */
      "HEAT": {
        "i": 3,
        "text": "Теплоэнергия",
      },
      /**
       * Газ
       */
      "GAS": {
        "i": 4,
        "text": "Газ",
      },
      /**
       * Электроэнергия
       */
      "ELECTRICITY": {
        "i": 5,
        "text": "Электроэнергия",
      },
    },
  },
  /**
   * Тип тарифного плана
   */
  "TemplateDevice.PlanType": {
    "kind": "enum",
    "text": "Тип тарифного плана",
    "values": {
      /**
       * Значение не указано
       */
      "PLAN_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Однотарифный
       */
      "SINGLE": {
        "i": 1,
        "text": "Однотарифный",
      },
      /**
       * Двухтарифный
       */
      "DOUBLE": {
        "i": 2,
        "text": "Двухтарифный",
      },
      /**
       * Трёхтарифный
       */
      "TRIPLE": {
        "i": 3,
        "text": "Трёхтарифный",
      },
    },
  },
  /**
   * Справочник типов направлений сортировки
   */
  "TemplateDevicePaging.DirectionType": {
    "kind": "enum",
    "text": "Справочник типов направлений сортировки",
    "values": {
      /**
       * Значение не указано
       */
      "DIRECTION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * От большего к меньшему
       */
      "DESC": {
        "i": 1,
        "text": "От большего к меньшему",
      },
      /**
       * От меньшего к большему
       */
      "ASC": {
        "i": 2,
        "text": "От меньшего к большему",
      },
    },
  },
  /**
   * Справочник типов значений сортировки
   */
  "TemplateDevicePaging.OrderByType": {
    "kind": "enum",
    "text": "Справочник типов значений сортировки",
    "values": {
      /**
       * Значение не указано
       */
      "ORDER_BY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * По идентификатору
       */
      "ID": {
        "i": 1,
        "text": "По идентификатору",
      },
      /**
       * По типу энергоресурса
       */
      "METRIC_TYPE": {
        "i": 2,
        "text": "По типу энергоресурса",
      },
      /**
       * По модели счетчика
       */
      "MODEL": {
        "i": 3,
        "text": "По модели счетчика",
      },
    },
  },
  /**
   * Справочник типа архивности показаний.
   * Используется для указания за какой период произошло измерение.
   * По умолчанию CURRENT
   */
  "TemplateIndicator.ArchiveType": {
    "kind": "enum",
    "text": "Справочник типа архивности показаний.\nИспользуется для указания за какой период произошло измерение.\nПо умолчанию CURRENT",
    "values": {
      /**
       * Значение не указано
       */
      "ARCHIVE_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Текущие показания
       */
      "CURRENT": {
        "i": 1,
        "text": "Текущие показания",
      },
      /**
       * За 30 мин
       */
      "HALFHOUR": {
        "i": 2,
        "text": "За 30 мин",
      },
      /**
       * За час
       */
      "HOUR": {
        "i": 3,
        "text": "За час",
      },
      /**
       * За суток
       */
      "DAY": {
        "i": 4,
        "text": "За суток",
      },
      /**
       * За месяц
       */
      "MONTH": {
        "i": 5,
        "text": "За месяц",
      },
      /**
       * За год
       */
      "YEAR": {
        "i": 6,
        "text": "За год",
      },
    },
  },
  /**
   * Справочник типов измерений
   */
  "TemplateIndicator.SignType": {
    "kind": "enum",
    "text": "Справочник типов измерений",
    "values": {
      /**
       * Значение не указано
       */
      "SIGN_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Абсолютный показатель
       */
      "ABSOLUTE_DS": {
        "i": 1,
        "text": "Абсолютный показатель",
      },
      /**
       * Абсолютный расход ресурса
       */
      "ABSOLUTE_RC": {
        "i": 2,
        "text": "Абсолютный расход ресурса",
      },
      /**
       * Интервальный показатель состояния
       */
      "INTERVAL_DS": {
        "i": 3,
        "text": "Интервальный показатель состояния",
      },
      /**
       * Интервальный расход ресурса
       */
      "INTERVAL_RC": {
        "i": 4,
        "text": "Интервальный расход ресурса",
      },
      /**
       * Текущее состояние
       */
      "CURRENT_DS": {
        "i": 5,
        "text": "Текущее состояние",
      },
      /**
       * Текущее состояние ресурса
       */
      "CURRENT_RS": {
        "i": 6,
        "text": "Текущее состояние ресурса",
      },
      /**
       * Объём
       */
      "VOLUME": {
        "i": 7,
        "text": "Объём",
      },
      /**
       * Параметр конфигурации
       */
      "PARAMETER": {
        "i": 8,
        "text": "Параметр конфигурации",
      },
      /**
       * Флаг состояния
       */
      "FLAG": {
        "i": 9,
        "text": "Флаг состояния",
      },
    },
  },
  /**
   * Справочник типов единиц измерений
   */
  "TemplateIndicator.UnitType": {
    "kind": "enum",
    "text": "Справочник типов единиц измерений",
    "values": {
      /**
       * Значение не указано
       */
      "UNIT_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Процент
       */
      "PERCENT": {
        "i": 1,
        "text": "Процент",
      },
      /**
       * Градус по Цельсию
       */
      "C": {
        "i": 2,
        "text": "Градус по Цельсию",
      },
      /**
       * Ватт
       */
      "WT": {
        "i": 3,
        "text": "Ватт",
      },
      /**
       * Гигакалория
       */
      "GKAL": {
        "i": 4,
        "text": "Гигакалория",
      },
      /**
       * Количество
       */
      "VALUE": {
        "i": 5,
        "text": "Количество",
      },
      /**
       * Киловaтт-час
       */
      "KWH": {
        "i": 6,
        "text": "Киловaтт-час",
      },
      /**
       * Килограмм на квадратный сантиметр
       */
      "KG_CM2": {
        "i": 7,
        "text": "Килограмм на квадратный сантиметр",
      },
      /**
       * Килограмм-сила на квадратный сантиметр
       */
      "KGF_CM2": {
        "i": 8,
        "text": "Килограмм-сила на квадратный сантиметр",
      },
      /**
       * Кубический метр
       */
      "M3": {
        "i": 9,
        "text": "Кубический метр",
      },
      /**
       * Кубический метр в час
       */
      "M3_H": {
        "i": 10,
        "text": "Кубический метр в час",
      },
      /**
       * Мегапаскаль
       */
      "MPA": {
        "i": 11,
        "text": "Мегапаскаль",
      },
      /**
       * Миллисекунда
       */
      "MS": {
        "i": 12,
        "text": "Миллисекунда",
      },
      /**
       * Флаг состояния
       */
      "BOOLEAN": {
        "i": 13,
        "text": "Флаг состояния",
      },
      /**
       * Тонна
       */
      "T": {
        "i": 14,
        "text": "Тонна",
      },
      /**
       * Тонна в час
       */
      "T_H": {
        "i": 15,
        "text": "Тонна в час",
      },
      /**
       * Час
       */
      "H": {
        "i": 16,
        "text": "Час",
      },
      /**
       * Безразмерная величина
       */
      "NON_MEASURABLE": {
        "i": 17,
        "text": "Безразмерная величина",
      },
      /**
       * Импульс
       */
      "IMP": {
        "i": 18,
        "text": "Импульс",
      },
      /**
       * Джоуль
       */
      "J": {
        "i": 19,
        "text": "Джоуль",
      },
      /**
       * Килоджоуль
       */
      "KJ": {
        "i": 20,
        "text": "Килоджоуль",
      },
      /**
       * Гигаджоуль
       */
      "GJ": {
        "i": 21,
        "text": "Гигаджоуль",
      },
      /**
       * Ватт-час
       */
      "WTH": {
        "i": 22,
        "text": "Ватт-час",
      },
      /**
       * Киловатт
       */
      "KWT": {
        "i": 23,
        "text": "Киловатт",
      },
      /**
       * Минута
       */
      "MIN": {
        "i": 24,
        "text": "Минута",
      },
      /**
       * Секунда
       */
      "S": {
        "i": 25,
        "text": "Секунда",
      },
    },
  },
  /**
   * Посредники получения показаний
   */
  "TemplateIndicator.VendorType": {
    "kind": "enum",
    "text": "Посредники получения показаний",
    "values": {
      /**
       * Значение не указано
       */
      "VENDOR_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Энвайро
       */
      "ENVIRO": {
        "i": 1,
        "text": "Энвайро",
      },
      /**
       * Лартех
       */
      "LARTECH": {
        "i": 2,
        "text": "Лартех",
      },
      /**
       * РТК
       */
      "RTK": {
        "i": 3,
        "text": "РТК",
      },
    },
  },
  /**
   * Справочник типов направлений сортировки
   */
  "TemplateIndicatorPaging.DirectionType": {
    "kind": "enum",
    "text": "Справочник типов направлений сортировки",
    "values": {
      /**
       * Значение не указано
       */
      "DIRECTION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * От большего к меньшему
       */
      "DESC": {
        "i": 1,
        "text": "От большего к меньшему",
      },
      /**
       * От меньшего к большему
       */
      "ASC": {
        "i": 2,
        "text": "От меньшего к большему",
      },
    },
  },
  /**
   * Справочник типов значений сортировки
   */
  "TemplateIndicatorPaging.OrderByType": {
    "kind": "enum",
    "text": "Справочник типов значений сортировки",
    "values": {
      /**
       * Значение не указано
       */
      "ORDER_BY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * По идентификатору
       */
      "ID": {
        "i": 1,
        "text": "По идентификатору",
      },
      /**
       * По типу измерений
       */
      "SIGN_TYPE": {
        "i": 2,
        "text": "По типу измерений",
      },
      /**
       * По типу архивности показаний
       */
      "ARCHIVE_TYPE": {
        "i": 3,
        "text": "По типу архивности показаний",
      },
    },
  },
}